var option_webview_default = {
  "option": "PyvIU",
  "user_choice": "Jnx-l",
  "check": "h-4sJ",
  "image": "t9NO2",
  "input": "cgi-v",
  "title": "_2j7Kk",
  "centered": "y8Haj",
  "with_result": "v2UBm",
  "list": "EpRFB",
  "with_image": "X3YFP",
  "progress": "bME2q",
  "progress_value": "wmc7I",
  "label": "d9Bxu",
  "cta": "TbU71",
  "adornment_icon": "cnuEw",
  "remove": "dsh2k",
  "removeButton": "NjiNQ",
  "removeButtonIcon": "ga3b2",
  "overlay": "_5wTr8",
  "shown": "_482le",
  "dark": "h8p2I",
  "spinner": "GwYYY",
  "spin": "k5FFw",
  "grid": "PmCAH"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
